<template>
    <iframe
        class="adv-iframe"
        :src="shareUrl"
        seamless="seamless"
        :style="styleObj"
        :width="width"
        :height="height"
        title="Video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
    />
</template>

<script setup>

import {computed} from "vue";
import myUtil from "@/util/util";

const props = defineProps(["width", "height", "videoUrl"])

const styleObj = computed(() => {
    const obj = {
        width: `${props.width}px`,
        height: `${props.height}px`
    }

    return obj
})

const shareUrl = computed(() => {
    let url = props.videoUrl

    if (myUtil.isNotEmpty(url)){
        let index = url.indexOf("/embed")

        if (index == -1){
            if (url.indexOf("?v=") !== -1){
                index = url.lastIndexOf("?v=")

                if (index > -1){
                    url = url.substring(index + 3)
                    url = `https://www.youtube.com/embed/${url}`
                }
            }else{
                index = url.lastIndexOf("/")

                if (index > -1){
                    url = url.substring(index)
                    url = `https://www.youtube.com/embed${url}`
                }
            }
        }
    }

    return url
})

</script>

<style scoped>

.adv-iframe {
    border: none;

}

</style>